<template>
    <div class="container mt-4">
        <h2>{{ $t('pollQuestion') }}</h2>
        <form :action="selectedUrl"
              method="POST"
              ref="form"
              enctype="multipart/form-data"
              @submit.prevent="submit">

            <!-- Iterate over pollQuestions to create dynamic inputs -->
            <div v-for="question in pollQuestions" :key="question.id" class="mt-4 mb-4">

                <!-- MCQ Question with options -->
                <div v-if="question.question_type === 'mcq' && Array.isArray(question.options)">
                    <app-form-group
                        :label="question.question_text || ''"
                        type="radio-buttons"
                        :name="'mcq_' + question.id"
                        :list="question.options.map(option => ({
                            id: option?.option_text || '',
                            value: option?.option_text || ''
                        }))"
                            v-model="formData.mcqAnswers[question.id]"
                        :error-message="$errorMessage(errors, 'mcqAnswers.' + question.id)"
                    />
                </div>

                <!-- Rating Question -->
                <div v-else-if="question.question_type === 'rating'">
                    <app-form-group
                        :label="question.question_text || ''"
                        type="radio-buttons"
                        :name="'rating_' + question.id"
                        :list="[
                            { id: $t('polls.rating_very_poor'), value: '😫 Very Poor', text: 'Very Poor (😫)' },
                            { id: $t('polls.rating_poor'), value: '😕 Poor', text: 'Poor (😕)' },
                            { id: $t('polls.rating_average'), value: '😐 Average ', text: 'Average (😐)' },
                            { id: $t('polls.rating_good'), value: '😊 Good', text: 'Good (😊)' },
                            { id: $t('polls.rating_excellent'), value: '🤩 Excellent', text: 'Excellent (🤩)' }
                        ]"
                        v-model="formData.ratingAnswers[question.id]"
                        :error-message="$errorMessage(errors, 'ratingAnswers.' + question.id)"
                    />
                </div>

                <!-- Open-ended Question -->
                <div v-else-if="question.question_type === 'open-ended'">
                    <app-form-group
                        :label="question.question_text || ''"
                        type="textarea"
                        :name="'openEndedAnswers_' + question.id"
                        v-model="formData.openEndedAnswers[question.id]"
                        :placeholder="$textAreaPlaceHolder('answer')"
                        :error-message="$errorMessage(errors, 'openEndedAnswers.' + question.id)"
                    />
                </div>

            </div>

            <!-- Submit Button -->
            <div class="mt-3">
                <button class="btn btn-primary" type="submit" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                    {{ $t('save') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import { errorMessageInArray, formDataAssigner } from "../../../../../common/Helper/Support/FormHelper";
import {axiosPost, urlGenerator} from "../../../../../common/Helper/AxiosHelper";
import {POLL_WEB} from "../../../../Config/ApiUrl";

export default {
    name: "PollCreateEdit",
    mixins: [FormHelperMixins, ModalMixin],
    props: {
        pollQuestions: {
            type: Array,
            required: true,
            default: () => []
        },
        value: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            errorMessageInArray,
            loading: false,
            message: '',
            errors: {},
            fieldStatus: {},
            formData: {
                mcqAnswers: {},
                ratingAnswers: {},
                openEndedAnswers: {}
            }
        };
    },
    mounted() {
        this.pollQuestions.forEach(question => {
            if (question.question_type === 'mcq') {
                this.$set(this.formData.mcqAnswers, question.id, '');
            } else if (question.question_type === 'rating') {
                this.$set(this.formData.ratingAnswers, question.id, '');
            } else if (question.question_type === 'open-ended') {
                this.$set(this.formData.openEndedAnswers, question.id, '');
            }
        });
    },
    methods: {
        submit() {
            this.loading = true;
            // Create a deep copy of formData
            let cleanedFormData = JSON.parse(JSON.stringify(this.formData));

            // Remove empty answer objects
            Object.keys(cleanedFormData).forEach(key => {
                const group = cleanedFormData[key];
                if (Object.values(group).every(answer => answer === '' || answer === null || answer === undefined)) {
                    delete cleanedFormData[key];
                }
            });
            const form = formDataAssigner(new FormData(), cleanedFormData);
            axiosPost(this.apiUrl.POLL_SUBMIT, form).then(({ data }) => {
                this.loading = false;
                $('#poll-modal').modal('hide');
                $('.modal-backdrop').remove();
                this.showModal = false;
                this.toastAndReload(data.message, 'poll-response-table');
                setTimeout(() => {
                    window.location.href = urlGenerator(this.apiUrl.POLL_WEB);
                }, 2000);
            }).catch(({ response }) => {
                this.loading = false;
                this.message = '';
                this.errors = response?.data?.errors || {};
                this.fieldStatus.isSubmit = true;
                if (response.status !== 422) {
                    this.$toastr.e(response.data?.message || response.statusText);
                }
            });
        },
        afterSuccess({ data }) {
            this.formData = {
                mcqAnswers: {},
                ratingAnswers: {},
                openEndedAnswers: {}
            };
            $('#poll-modal').modal('hide');
            this.toastAndReload(data.message, 'poll-response-table');
            this.$emit('input', false);
            window.location.reload();
        },
        afterError(response) {
            this.loading = false;
            this.errors = response?.data?.errors || {};
        }
    }
}
</script>
